import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';

import { AuthProvider } from './auth.provider';

@Injectable()
export abstract class CookieProvider implements AuthProvider {

  constructor(protected cookieService: CookieService, public cookieName: string) { }

  isAuthenticated() {
    return this.cookieService.check(this.cookieName);
  }

  signOut(): Observable<boolean> {
    this.clearCookie();
    return Observable.of(true);
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({ withCredentials: true });
  }

  protected clearCookie() {
    if (this.cookieService.check(this.cookieName))
      this.cookieService.delete(this.cookieName);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/providers/cookie.provider.ts